/**
 * Serina guarantee reconciler (single source of truth).
 * Keeps exactly one free guarantee line in the cart:
 *   1-2 real items -> 60-day variant, 3+ -> 1-year variant, 0 -> none.
 * The line is added with a public line-item property so Shopify checkout
 * displays it under the item, e.g.:
 *   無料特典: ご注文に無料で含まれています
 * Guarantee lines without the property (added by older script versions)
 * are replaced so every cart ends up with the labeled line.
 * window.__srGuard prevents double-init if an inline copy still exists.
 */
(function(){
  var V60=64208605446513,V1Y=64208605479281;
  var PROP_KEY='無料特典',PROP_VAL='ご注文に無料で含まれています';
  var busy=false;
  function labeled(it){return !!(it.properties&&it.properties[PROP_KEY]);}
  function rec(){
    if(busy)return;busy=true;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var real=0,has60=null,has1y=null;
      c.items.forEach(function(it){
        if(it.variant_id===V60)has60=it;
        else if(it.variant_id===V1Y)has1y=it;
        else real+=it.quantity;
      });
      var want=real===0?null:(real>=3?V1Y:V60);
      var keep60=!!(has60&&want===V60&&labeled(has60));
      var keep1y=!!(has1y&&want===V1Y&&labeled(has1y));
      var upd={};
      if(has60&&!keep60)upd[V60]=0;
      if(has1y&&!keep1y)upd[V1Y]=0;
      if(keep60&&has60.quantity!==1)upd[V60]=1;
      if(keep1y&&has1y.quantity!==1)upd[V1Y]=1;
      var add=want&&!keep60&&!keep1y;
      var chg=add||Object.keys(upd).length>0;
      var props={};props[PROP_KEY]=PROP_VAL;
      var p=Promise.resolve();
      if(Object.keys(upd).length)p=p.then(function(){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd})})});
      if(add)p=p.then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:want,quantity:1,properties:props}]})})});
      return p.then(function(){
        busy=false;
        if(chg&&location.pathname.indexOf('/cart')===0){
          if(!sessionStorage.getItem('srgr')){sessionStorage.setItem('srgr','1');location.reload();}
        }else{sessionStorage.removeItem('srgr');}
      });
    }).catch(function(){busy=false;});
  }
  if(!window.__srGuard){
    window.__srGuard=1;
    var of=window.fetch;
    window.fetch=function(){
      var u=arguments[0];u=(u&&u.url)||u||'';
      var p=of.apply(this,arguments);
      if(typeof u==='string'&&/\/cart\/(add|change|update|clear)/.test(u)&&!busy){p.then(function(){setTimeout(rec,400);});}
      return p;
    };
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',rec);}else{rec();}
  }
})();
